/**
 * Created by WebStorm.
 * User: liulin
 * Date: 2018/8/28
 * Time: 下午5:54
 */
import { getCurCursorPosition, markdownLock } from '../../../mixin/docs'

export default {
  type: 'code',
  regexObj: /^(?:``` (.*))/gm,
  styleAttributes: {
    bold: true
  },
  options: null,
  handleMarkdown: (quill) => {
    markdownLock(true)
    const selectIndex = getCurCursorPosition(quill)
    if (selectIndex !== null) {
      quill.deleteText(selectIndex - 4, 4)
      quill.format('code-block', true)
      // let ops = [
      //   [{retain: selectIndex - 4}, {delete: 4}],
      //   [{retain: selectIndex - 4}, {attributes: {'code-block': true}, retain: 1}]
      // ]
      // self.$emit('send-message', ops)
    }
    markdownLock(false)
  }
}



// WEBPACK FOOTER //
// ./src/components/quill/markdown/code.js